import React from 'react'
import { connect } from 'react-redux'

import styles from './FullscreenLoader.module.css'

const FullscreenLoader = ({ isShown, message }) => {
  if (!isShown) {
    return null
  }
  return (
    <div className={styles.fullscreenLoader}>
      <div className={styles.content}>
        <i className="fa fa-spinner fa-pulse fa-3x fa-fw" />
        {message &&
          <p className={styles.message}>
            {message}
          </p>}
      </div>
    </div>
  )
}

const mapStateToProps = ({ form }) => ({
  isShown: form.get('isFullscreenLoaderShown'),
  message: form.get('fullscreenLoaderMessage')
})

export default connect(mapStateToProps)(FullscreenLoader)
